import * as React from "react";
const FillHeartIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={23}
    viewBox="0 0 24 23"
    fill="none"
    {...props}
  >
    <path
      d="M11.0614 4.13233L11.8572 5.17814L12.653 4.13233C13.6961 2.7615 15.3069 1.93433 17.0598 1.93433C20.119 1.93433 22.6368 4.46768 22.6368 7.61391C22.6368 9.18197 22.0203 10.6354 20.9255 11.7053L20.9176 11.7129L20.91 11.7208L11.8572 20.9648L2.63296 11.5475C1.62934 10.4825 1.07764 9.08783 1.07764 7.61391C1.07764 4.46768 3.59535 1.93433 6.65456 1.93433C8.40745 1.93433 10.0183 2.7615 11.0614 4.13233Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default FillHeartIcon;
